import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, of, throwError } from 'rxjs';
import { SwapcontractWizardDataV26Service } from 'src/app/services-v26/wizards/swapcontract-wizard-data-v26.service';
import { SwapContractWizardActionsV26 } from '.';

@Injectable()
export class SwapContractWizardStoreEffects {
  validation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SwapContractWizardActionsV26.validateSwapRequest),
      concatMap(({ request }) =>
        this.swapContractWizardService.validateSwapLicense(request).pipe(
          map((response) => {
            if (response) {
              return SwapContractWizardActionsV26.validateSwapRequestResult({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(SwapContractWizardActionsV26.validateSwapRequestFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  newOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SwapContractWizardActionsV26.createNewOrder),
      concatMap(({ newOrder }) =>
        this.swapContractWizardService.swapLicense(newOrder).pipe(
          map((response) => {
            if (response) {
              return SwapContractWizardActionsV26.createNewOrderSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(SwapContractWizardActionsV26.createNewOrderFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private swapContractWizardService: SwapcontractWizardDataV26Service,
  ) {}
}
